export const SPRING = 'spring'
export const SUMMER = 'summer'
export const FALL = 'fall'
